import React, { useEffect, useState } from "react";
import "./menuItems.scss";

function FilteredMenuItems(props) {
  const [items, setItems] = useState({});

  useEffect(() => {
    // Create an object to store items by itemSubCategory
    const itemsBySubCategory = {};

    for (const item of props.filteredMenuItems) {
      var itemCategory;
      if (!item.itemSubCategory) {
        itemCategory = item.itemCategory;
      } else {
        itemCategory = item.itemSubCategory;
      }

      if (itemCategory) {
        if (!itemsBySubCategory[itemCategory]) {
          // Initialize an array for the itemSubCategory if it doesn't exist
          itemsBySubCategory[itemCategory] = [];
        }

        // Check if an item with the same itemName already exists in the array
        const duplicateItemIndex = itemsBySubCategory[
          itemCategory
        ].findIndex((existingItem) => existingItem.itemName === item.itemName);

        if (duplicateItemIndex === -1) {
          // If no duplicate item found, push the item to the array
          itemsBySubCategory[itemCategory].push(item);
        }
      }
    }

    // itemsBySubCategory now contains items grouped by itemSubCategory
    setItems(itemsBySubCategory);
  }, [props.filteredMenuItems]);

  async function toggleItemModal(item) {
    item.active = "Active";
    props.setSelectedItem(item);
    props.setShowItemModal(true);
  }

  return (
    <>
      {props.filteredMenuItems.length > 0 ? (
        <div className="list">
          {Object.keys(items).map((category) => (
            <div className="category" key={category}>
              <h2 className="categoryName">{category}</h2>
              {items[category].map((item) => (
                <div key={item.menuItemID} className="item-card" onClick={() => toggleItemModal(item)}>
                  <div className="itemName">{item.itemName}</div>
                  {item.itemDescription && <p className="description">{item.itemDescription}</p>}
                  <p className="price">${item.itemPrice.toFixed(2)}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div className="no-items-found">
          <div className="no-items-content">
            <svg className="no-items-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <h3 className="no-items-title">No items found</h3>
            <p className="no-items-message">Try adjusting your search terms or browse our full menu</p>
          </div>
        </div>
      )}
    </>
  );
}

export default FilteredMenuItems;
